const comments = [
  {
    name: '漫画爱好者小明',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20male%20character%20portrait%20with%20warm%20smile%2C%20simple%20cream%20background%2C%20clean%20illustration%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    text: '亲亲漫画真的是我用过最顺手的漫画平台了！下拉式阅读太舒服了，而且完全不收费，追了快两年的韩漫，更新速度超快，强烈推荐给所有漫画党！',
    date: '3天前',
    likes: 1286,
    tag: '韩漫读者',
  },
  {
    name: '二次元小樱',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20female%20character%20portrait%20with%20gentle%20expression%2C%20simple%20cream%20background%2C%20clean%20illustration%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    text: '从日漫追到国漫，亲亲漫画的资源真的太全了！好多之前找不到的冷门作品这里都有，而且全本完结的漫画直接一口气看到结局，体验超棒！',
    date: '1周前',
    likes: 953,
    tag: '日漫读者',
  },
  {
    name: '熬夜追漫人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20character%20with%20glasses%20portrait%2C%20friendly%20expression%2C%20simple%20cream%20background%2C%20clean%20illustration%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    text: '每天睡前必刷一遍亲亲漫画看有没有更新，韩漫的剧情太上头了，画风也超美！免费又不用注册，打开就能看，真的良心平台。',
    date: '2周前',
    likes: 2104,
    tag: '忠实用户',
  },
  {
    name: '漫游指南针',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20with%20headphones%20portrait%2C%20cool%20expression%2C%20simple%20cream%20background%2C%20clean%20illustration%20style&width=100&height=100&seq=avatar-04&orientation=squarish',
    text: '作为国漫的忠实粉丝，看到亲亲漫画上的国漫专区真的很感动。国风玄幻类的作品越来越多了，每一部都画得超用心，必须支持！',
    date: '3周前',
    likes: 867,
    tag: '国漫读者',
  },
  {
    name: '漫画收藏家',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20with%20hat%20portrait%2C%20thoughtful%20expression%2C%20simple%20cream%20background%2C%20clean%20illustration%20style&width=100&height=100&seq=avatar-05&orientation=squarish',
    text: '亲亲漫画的全本完结区就是我的天堂！不用等更新，一口气看到结局的感觉太爽了。收藏列表已经塞了上百部作品，根本停不下来。',
    date: '1个月前',
    likes: 1542,
    tag: '重度读者',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 mb-3">
              读者心声
            </h2>
            <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
              来自亲亲漫画真实读者的评价，每一份喜爱都是我们不断前进的动力
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
            {comments.map((comment, i) => (
              <div
                key={i}
                className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 flex flex-col"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-100 flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div className="min-w-0">
                    <div className="text-sm font-semibold text-foreground-900 truncate">{comment.name}</div>
                    <span className="text-[10px] text-accent-600 bg-accent-100 px-1.5 py-0.5 rounded-full font-medium">
                      {comment.tag}
                    </span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-4">
                  &ldquo;{comment.text}&rdquo;
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{comment.date}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-thumb-up-line"></i>
                    {comment.likes}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}